import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set) => ({
      claims: null,
      token: null,
      refreshToken: null,
      isAuthenticated: false,
      userId: null,
      userName: null,

      // Kullanıcı bilgilerini güncelleme fonksiyonu
      setUser: (claims, token, refreshToken, userId, userName) =>
        set({
          claims,
          token,
          refreshToken,
          isAuthenticated: !!token,
          userId,
          userName,
        }),
    }),
    {
      name: 'berp-m-auth-storage',
    }
  )
);
